<template>
  <VView class="rules" back-button-to="/menu" :header="$t('rules.header')">
    <div class="rules__list">
      <transition name="bounceLeft" appear><VText center v-html="$t('rules.content.0')" /></transition>
      <transition name="bounceRight" appear><VText center v-html="$t('rules.content.1')" /></transition>
      <transition name="bounceLeft" appear><VText center v-html="$t('rules.content.2')" /></transition>
      <transition name="bounceUp" appear><VText center v-html="$t('rules.content.3')" /></transition>
    </div>
  </VView>
</template>

<script>
export default {
  name: 'Rules',
};
</script>

<style lang="scss" scoped>
.rules {
}
</style>
